var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-help",
  "use": "ring-icon-help-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"ring-icon-help\"><path d=\"M16 32C7.164 32 0 24.836 0 16S7.164 0 16 0s16 7.164 16 16-7.164 16-16 16zm0-29.09C8.77 2.91 2.91 8.77 2.91 16S8.77 29.09 16 29.09 29.09 23.23 29.09 16 23.23 2.91 16 2.91zm1.455 15.793v1.66h-2.91v-2.908c0-.804.653-1.455 1.456-1.455a2.91 2.91 0 1 0-2.908-2.91c0 .533.153 1.026.403 1.456H10.39a5.73 5.73 0 0 1-.207-1.455 5.818 5.818 0 0 1 11.636 0c0 2.708-1.858 4.964-4.365 5.613zm0 6.024h-2.91v-2.91h2.91v2.91z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id